import { Image, UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { Overlay } from '../Overlay';

import { type ThumbnailProps } from './types';

import styles from './Thumbnail.css';

export const Thumbnail: FC<ThumbnailProps> = props => {
  const { overlay, src, alt = 'Ошибка загрузки фото' } = props;
  const isNarrow = useListingLayoutIsNarrowSelector();

  return (
    <div className={clsx(styles['container'], !!overlay && styles['container-with-overlay'])}>
      <Image alt={alt} src={src} />
      {!!overlay && (
        <Overlay bgc="black_40" isCompact={isNarrow}>
          <UIText2 color="white_100" textAlign="center">
            {overlay.text}
          </UIText2>
        </Overlay>
      )}
    </div>
  );
};
